import * as prismicH from "@prismicio/helpers";

/**
 * Post list item date component
 */
export const PostDate = ({ date }) => {
  // Format the date to M d, Y
  const dateFormat = {
    month: "short",
    day: "2-digit",
    year: "numeric",
  };
  const displayDate = new Intl.DateTimeFormat("en-US", dateFormat).format(
    prismicH.asDate(date)
  );

  return (
    <p className="blog-post-meta py-4 m-0">
      <time className="created-at detail">{displayDate}</time>
    </p>
  );
};
